import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/_services';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent implements OnInit {

  public iconOnlyToggled = false;
  public sidebarToggled = false;
  authenticationService: AuthenticationService;
  isNavbarCollapsed = true;
  org_name: '';
  defConf: any;
  current: any;
  demo: any;
  title:string;
  logo_url= "/assets/images/logo_ltax.png";

  constructor(
    // config: NgbDropdownConfig,
    authenticationService: AuthenticationService

    ) {
    this.demo = environment.DEMO;
    // config.placement = 'bottom-right';
    this.authenticationService = authenticationService;
  }


  ngOnInit() {
      //this.title = environment.title;

    switch (new Date().getDay()) {
      case 0:
        document.querySelector('.navbar').classList.add('navbar-sun');
        break;
      case 1:
        document.querySelector('.navbar').classList.add('navbar-mon');
        break;
      case 2:
        document.querySelector('.navbar').classList.add('navbar-tue');
        break;
      case 3:
        document.querySelector('.navbar').classList.add('navbar-wed');
        break;
      case 4:
        document.querySelector('.navbar').classList.add('navbar-thu');
        break;
      case 5:
        document.querySelector('.navbar').classList.add('navbar-fri');
        break;
      case 6:
        document.querySelector('.navbar').classList.add('navbar-sat');
        break;
    }

    // document.querySelector('.navbar').classList.add('navbar-pink');
    this.loadData();
  }

  loadData(){
    this.defConf = JSON.parse(localStorage.getItem('defConfig'));
    this.current = JSON.parse(localStorage.getItem('currentUser')); 
    if (this.defConf.logo !=undefined && this.defConf.logo !=null && this.defConf.logo !=''){
      this.logo_url = this.defConf.logo;
    }
  }

  toggleSidebar() {
    const body = document.querySelector('body');
    if ((!body.classList.contains('sidebar-toggle-display')) && (!body.classList.contains('sidebar-absolute'))) {
      this.iconOnlyToggled = !this.iconOnlyToggled;
      if (this.iconOnlyToggled) {
        body.classList.add('sidebar-icon-only');
      } else {
        body.classList.remove('sidebar-icon-only');
      }
    } else {
      this.sidebarToggled = !this.sidebarToggled;
      if (this.sidebarToggled) {
        body.classList.add('sidebar-hidden');
      } else {
        body.classList.remove('sidebar-hidden');
      }
    }
  }

  toggleRightSidebar() {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }

  logout() {
    this.authenticationService.logout();
  }


}
